import * as CONSTANTS from "./constants";

export const locationSelector = state => state.location;

export const hasLocationSelector = state =>
  state.location.isDone && state.location.locationDetails !== undefined;

export const matchSelector = state => state.location.locationDetails;

const initialState = {
  currentLocation: "",
  locationDetails: undefined,
  isDone: false,
  suggestions: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.FIND_CURRENT_LOCATION:
    case CONSTANTS.SET_CURRENT_LOCATION:
      return {
        ...state,
        isDone: true,
        currentLocation: action.payload.location,
        locationDetails: action.payload.details
      };

    case CONSTANTS.SET_LOCATION_QUERY:
      return {
        ...state,
        isDone: false,
        currentLocation: action.payload.value
      };

    case CONSTANTS.GET_SUGGESTIONS:
      return {
        ...state,
        isDone: false,
        suggestions: action.payload.suggestions
      };

    case CONSTANTS.CLEAR_SUGGESTIONS:
      return {
        ...state,
        suggestions: []
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/services/location/reducer.js